/* eslint no-param-reassign: 0 */

import getUuid from 'widget/helpers/uuid';
import { MESSAGE_STATUS, MESSAGE_TYPE } from 'shared/constants/messages';
import format from 'date-fns/format';

export default () => {
  if (!Array.prototype.last) {
    Object.assign(Array.prototype, {
      last() {
        return this[this.length - 1];
      },
    });
  }
};

export const isEmptyObject = obj =>
  Object.keys(obj).length === 0 && obj.constructor === Object;

export const isJSONValid = value => {
  try {
    JSON.parse(value);
  } catch (e) {
    return false;
  }
  return true;
};

export const getTypingUsersText = (users = []) => {
  const count = users.length;
  const [firstUser, secondUser] = users;

  if (count === 1) {
    return ['TYPING.ONE', { user: firstUser.name }];
  }

  if (count === 2) {
    return [
      'TYPING.TWO',
      { user: firstUser.name, secondUser: secondUser.name },
    ];
  }

  return ['TYPING.MULTIPLE', { user: firstUser.name, count: count - 1 }];
};

export const createPendingMessage = data => {
  const timestamp = Math.floor(new Date().getTime() / 1000);
  const tempMessageId = getUuid();
  const { message, file } = data;
  const tempAttachments = [{ id: tempMessageId }];
  const pendingMessage = {
    ...data,
    content: message || null,
    id: tempMessageId,
    echo_id: tempMessageId,
    status: MESSAGE_STATUS.PROGRESS,
    created_at: timestamp,
    message_type: MESSAGE_TYPE.OUTGOING,
    conversation_id: data.conversationId,
    attachments: file ? tempAttachments : null,
  };

  return pendingMessage;
};

export const convertToAttributeSlug = text => {
  return text
    .toLowerCase()
    .replace(/[^\w ]+/g, '')
    .replace(/ +/g, '_');
};

export const convertToCategorySlug = text => {
  return text
    .toLowerCase()
    .replace(/[^\w ]+/g, '')
    .replace(/ +/g, '-');
};

export const convertToPortalSlug = text => {
  return text
    .toLowerCase()
    .replace(/[^\w ]+/g, '')
    .replace(/ +/g, '-');
};

/**
 * 秒数转换时:分:秒格式
 * @param value
 */
export function processtime(value) {
  var sec = parseInt(value, 10);
  var middle = 0; // 分
  var hour = 0; // 小时
  var result = '';
  if (sec > 60) {
    middle = parseInt(sec / 60, 10);
    sec = parseInt(sec % 60, 10);
    if (middle > 60) {
      hour = parseInt(middle / 60, 10);
      middle = parseInt(middle % 60, 10);
    }
  }
  result = sec < 10 ? '0' + parseInt(sec, 10) : '' + parseInt(sec, 10);
  if (middle > 0) {
    result =
      middle > 10
        ? parseInt(middle, 10) + ':' + result
        : '0' + parseInt(middle, 10) + ':' + result;
  } else {
    result = '00:' + result;
  }
  if (hour > 0) {
    result = '' + parseInt(hour, 10) + ':' + result;
  } else {
    result = '00:' + result;
  }
  return result;
}

/**
 * 格式化秒数 转换时:分:秒格式
 * @param value
 */
export function secondFormat(second) {
  var sec = parseInt(second, 10);
  var middle = 0; // 分
  var hour = 0; // 小时
  var day = 0; // 天
  var result = '';

  if (sec > 60) {
    middle = parseInt(sec / 60, 10);
    sec = parseInt(sec % 60, 10);
    if (middle > 60) {
      hour = parseInt(middle / 60, 10);
      middle = parseInt(middle % 60, 10);

      if (hour > 24) {
        day = parseInt(hour / 24, 10);
        hour = parseInt(hour % 24, 10);
      }
    }
  }

  if (middle > 0) {
    sec = String(sec).padStart(2, '0');
    if (hour > 0) {
      middle = String(middle).padStart(2, '0');
      if (day > 0) {
        hour = String(hour).padStart(2, '0');
        day = String(day);
        result = `${day}天${hour}:${middle}:${sec}`;
      } else {
        result = `${hour}:${middle}:${sec}`;
      }
    } else {
      result = `${middle}:${sec}`;
    }
  } else {
    result = `${sec}s`;
  }

  return result;
}

export function processTimeEdge(time) {
  if (time > 1) {
    return secondFormat(time);
  }
  return time.toString() + 's';
}

// 下载csv
export const downloadCsv = response => {
  let disposition = response.headers['content-disposition'];
  let match = disposition.match(/filename=(.+)/);
  let now = new Date();
  let filename = format(now, 'yyyy-MM-dd HH:mm:ss');
  if (match) {
    filename = decodeURI(match[1]);
  }
  let csvContent = 'data:text/csv;charset=utf-8,' + response.data;
  let encodedUri = encodeURI(csvContent);
  let link = document.createElement('a');
  link.href = encodedUri;
  // 对下载的文件命名
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};

export const getPopupContainer = () => {
  if (typeof document !== 'undefined') {
    return document.body;
  }
  return null;
};
